import moment from 'moment-timezone';
import { PERIOD } from './dateRanges';

/** Fill the selected calendar range, keeping missing days/months visible as zero. */
export function buildPatientRegistrations(rows, period, fromdate, todate, now = new Date()) {
  const monthly = Number(period) === PERIOD.LAST_3_MONTHS || Number(period) === PERIOD.THIS_YEAR;
  const unit = monthly ? 'month' : 'day';
  const keyFormat = monthly ? 'YYYY-MM' : 'YYYY-MM-DD';
  const counts = {};
  (rows || []).forEach((row) => {
    const key = monthly
      ? `${row.date_part_year || row.date_part_Year}-${String(row.date_part).padStart(2, '0')}`
      : String(row.to_date || '').split('T')[0];
    counts[key] = (counts[key] || 0) + (parseInt(row.count, 10) || 0);
  });
  const result = [];
  const end = monthly
    ? moment(todate).startOf(unit)
    : moment.min(moment(todate).startOf('day'), moment(now).startOf('day'));
  for (const cursor = moment(fromdate).startOf(unit); cursor.isSameOrBefore(end); cursor.add(1, unit)) {
    result.push({
      period: cursor.format(monthly ? 'MMM YYYY' : 'YYYY/MM/DD'),
      count: counts[cursor.format(keyFormat)] || 0,
    });
  }
  return result;
}



// WEBPACK FOOTER //
// ./src/components/dashboard2/patientRegistrations.js